module.exports = __webpack_public_path__ + "static/img/ross_noble_ani_extended_size_00002-fs8.50b0b95.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animation/ross_noble_ani_extended_size_00002-fs8.png
// module id = 156
// module chunks = 0